import router from '@/router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU.js'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import { MediaQueries } from 'vue-media-queries'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import App from './App.vue'
import store from './store'


const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

Vue.use(ElementUI, { locale });
Vue.use(store)
Vue.component('v-select', vSelect)

new Vue({
    router,
    mediaQueries: mediaQueries,
    store,
    render: h => h(App)
}).$mount('#app')